<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'maintainPlanList',
          title: '养护/检定计划列表'
        },
        {
          name: 'maintainPlanMeasure',
          title: '录入养护结果'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'save',
          text: '保存',
          type: 'primary'
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>计划编号：{{assertsCuringPlan.code}}</h4>
            <div>创建时间：{{assertsCuringPlan.createTime}}</div>
            <div>创建人：{{assertsCuringPlan.createUserName}}</div>
            <div>设备类型：{{assertsCuringPlan.typeStr}}</div>
            <div>计划状态：{{assertsCuringPlan.statusStr}}</div>
          </div>
        </div>
      </div>

      <div slot="content">
        <lk-card title="录入养护结果">
          <lk-table border :columns="columns" :data="assertsCuringHistoryVOs" class="plan-table requireAssetAdd"/>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>

<script>

import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import assets from '../../services/assets';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';

export default {
  name: 'CommonInput',
  components: {
    BaseFrame,
    // AnTable,
  },
  data() {
    return {
      id: '',
      assertsCuringPlan: {},
      purchaseReceiptImgInfoList: [],
      tempInput: '',
      assertsCuringHistoryVOs: [],
      columns: [
        // {
        //   title: '行号',
        //   minWidth: 80,
        //   render: (h, {index})=>{
        //     return h('span', index+1)
        //   }
        // },
        {
          title: '设备编码',
          minWidth: 116,
          key: 'assertsCode',
        },

        {
          title: '名称',
          minWidth: 116,
          key: 'assertsName',
        },
        {
          title: '型号',
          minWidth: 116,
          key: 'unitType',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'manufacturer',
        },
        {
          title: '养护内容',
          minWidth: 116,
          key: 'curingContent',
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.assertsCuringHistoryVOs[index].curingContent = e.target.value;
              },
            },
            props: {
              value: row.curingContent,
              maxlength: 50,
            },
          }),
        },
        {
          title: '养护结果',
          minWidth: 116,
          key: 'curingResult',
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.assertsCuringHistoryVOs[index].curingResult = e.target.value;
              },
            },
            props: {
              value: row.curingResult,
              maxlength: 50,
            },
          }),
        },
      ],
    };
  },
  methods: {
    resetTableData() {
      this.assertsCuringHistoryVOs = [];
    },
    resetInfo() {
      this.assertsCuringPlan = {};
    },
    onBtnClick(name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'save') {
        this.onSubmit('save');
      } else if (name === 'submit') {
        this.onSubmit('submit');
      }
    },
    onSubmit(flag) {
      // adapt data
      let addFunction = assets.savePlan;
      const assertsCuringPlan = {
        id: this.assertsCuringPlan.id,
        type: this.assertsCuringPlan.type,
      };
      let assertsCuringHistories = [];
      if (flag === 'submit') {
        addFunction = assets.submitPlan;
      }
      const messages = [];
      this.assertsCuringHistoryVOs.forEach((item) => {
        if (!item.curingContent || !item.curingResult) {
          messages.push('养护内容、养护结果不能为空！');
        }
      });
      if (messages.length > 0) {
        this.$Message.error(messages[0]);
        return;
      }
      assertsCuringHistories = this.assertsCuringHistoryVOs.map(item => ({
        id: item.id,
        curingContent: item.curingContent,
        curingResult: item.curingResult,
      }));
      const data = {
        assertsCuringPlan,
        assertsCuringHistories,
      };
      addFunction(data).then((res) => {
        const code = res.data.status;
        if (code === 200) {
          this.resetAll();
          this.jumpToList();
        } else {
          this.$Message.error(res.data.error);
        }
      });
      // reset
    },
    resetAll() {
      this.resetTableData();
      this.resetInfo();
    },
    jumpToList() {
      this.$router.push({
        name: 'maintainPlanList',
      });
    },
    onCancel() {
      this.resetAll();
      this.jumpToList();
    },
    getData(id) {
      if (!id) {
        return;
      }
      assets.planDetail({ id }).then((res) => {
        console.log(res);
        if (res.data.status === 200) {
          this.tableData = [];
          this.assertsCuringPlan = res.data.data.assertsCuringPlan;
          this.assertsCuringPlan.createTime = utils.formatTime(res.data.data.assertsCuringPlan.createTime, 'YYYY/MM/DD HH:mm');
          res.data.data.assertsCuringHistoryVOs.forEach((item) => {
            if (item.inspectionTime) {
              item.inspectionTime = utils.formatTime(item.inspectionTime, 'YYYY-MM-DD');
            } else {
              item.inspectionTime = '';
            }
          });
          this.assertsCuringHistoryVOs = res.data.data.assertsCuringHistoryVOs;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    this.getData(this.id);
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.rejectTable{
  margin-bottom: 16px;
}

</style>
